fx.ns("filters", class LayoutFilter extends fx.Filter {

	constructor(themeid, shape, zoom)
	{
        super();

        this._search = "recommended";
        this._themeid = themeid;
        this._shape = shape;

        this._zoom = zoom;

        if (this._zoom)
            this.on("updated", this._onZoomChanged, this._zoom);
    }

    get productType()
    {
        return this._productType;
    }

    set productType(val)
    {
        this._productType = val;
        this._changed = true;
        this.trigger("updated");
    }

    get shape()
    {
        return this._shape;
    }

    set shape(val)
    {
        this._shape = val;
        this._changed = true;
        this.trigger("updated");
    }

    get themeid()
    {
        return this._themeid;
    }

    set themeid(val)
    {
        this._themeid = val;
        this._changed = true;
        this.trigger("updated");
    }

    get single()
    {
        return this._single;
    }

    set single(val)
    {
        this._single = val;
        this._changed = true;
        this.trigger("updated");
    }
    
    get search()
    {
        return this._search;
    }

    set search(val)
    {
        this._search = val;
        this._changed = true;
        this.trigger("updated");
    }

    // used in order to show only double page layouts for Cover or Page
    get area()
    {
        return this._area;
    }

    set area(val)
    {
        if (this._area != val)
        {
            if (!this._area)
                this._changed = false;
            else
            if(this._area && this._area.data && val)
            {
                let previousSingleLayout = this._area.data.isCover || this._area.data.hasbackcover;
                let currentSingleLayout = val.data.isCover || val.data.hasbackcover;

                this._changed = previousSingleLayout != currentSingleLayout;
            }
            else 
                this._changed = true;
            
            this._area = val;

            if (this._changed)
                this.trigger("updated");
        }
    }


    // show recommended/1 photo/2 photos/3 photos/4 photos/more
    // Layout displayed in all cases :
    // - doublepage = 0
    // if doublepage == 1 : displayed only if same page_type_id (covers have slice, so double page layout can not be the same as pages)
	exec()
	{
        if (!this.rawData)
            return;

        this.transformedData = [];
        let singleTagAdded, doubleTagAdded, accountAdded;
        let rawData = this.rawData.sort(function(a, b){ return a.accountid - b.accountid });
        
        for (let i = 0; i < rawData.length; i++)
        {
            let layout = rawData.getItemAt( [i] );

            if (layout.shape != this.shape)
                continue;

            if (layout.product_type_id != this.productType)
                continue;

            if (this.productType == models.ProductType.BOOK)
            {                
                if (this.search == "recommended")
                {
                    if (layout.themeid == -1 && layout.accountid)
                    {
                        if (!accountAdded)
                        {
                            this.transformedData.push( {type : "label", text : fx.text('Vos mises en page')}  );
                            accountAdded = true;
                        }

                        this.transformedData.push( layout );
                    }

                    if ((layout.themeid == this.themeid) || (!this.themeid && layout.themeid != -1))
                    {
                        if (this._zoom && this._zoom.value != 100 && layout.doublepage)
                            continue;

                        if (!this._area && layout.doublepage)
                            continue;

                        if ((this._area && this._area.data && (this._area.data.hasbackcover || this._area.data.isCover)) && layout.doublepage)
                            continue;

                        if (!layout.doublepage && !singleTagAdded)
                        {
                            this.transformedData.push( {type : "label", text : fx.text('Pages simples')}  );
                            singleTagAdded = true;
                        }
                            
                        if (!this.single && layout.doublepage && !doubleTagAdded)
                        {
                            if (fx.browser.isMobile)
                                continue;
                            else
                            {
                                this.transformedData.push( {type : "label", text : fx.text('Pages doubles')}  );
                                doubleTagAdded = true;
                            }
                        }

                        if (this.single)
                        {
                            if (!layout.doublepage)
                                this.transformedData.push( layout );
                        }
                        else
                            this.transformedData.push( layout );

                    }   
                }
                else
                {
                    if (!layout.accountid && layout.themeid == -1 && (fx.get("app") == "config" || (fx.get("app") == "book" && layout.target == "")))
                    {
                        if (this.search == "+") 
                        {
                            if ( layout.num_photos > 4)
                                this.transformedData.push( layout );
                        }
                        else
                        if ( (this.search == 1) ? (layout.num_photos <= this.search) : (layout.num_photos == this.search)) 
                        {
                            this.transformedData.push( layout );
                        } 
                    }  
                }
            }
            else
            {
                this.transformedData.push( layout );
            }
        }        

		return this.transformedData;
	}	

    _onZoomChanged()
    {
        this._changed = true;
        this.trigger("updated");
    }
});